// A squirrel, modelled facing +X: a small russet body with a big curled tail
// arching over its back. Ported 1:1 from age-of-mcp's classic squirrel.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.024, 0), color: "#8a5a32",
      position: [0, 0.03, 0], scale: [1.3, 1.1, 0.9] },
    { geometry: new THREE.IcosahedronGeometry(0.017, 0), color: "#9a6638",
      position: [0.03, 0.052, 0] },                                    // head
    { geometry: new THREE.ConeGeometry(0.008, 0.014, 4), color: "#7a4d2a",
      position: [0.025, 0.072, 0.011] },                               // ear
    { geometry: new THREE.ConeGeometry(0.008, 0.014, 4), color: "#7a4d2a",
      position: [0.025, 0.072, -0.011] },
    // Big curled tail — three blobs arching up and over the back.
    { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#a06e3e",
      position: [-0.03, 0.045, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#a87542",
      position: [-0.04, 0.075, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#b07c48",
      position: [-0.025, 0.098, 0] },
  ];
  return parts;
}

export const squirrel = defineModel({
  id: "squirrel",
  batchId: "standard",
  name: "Squirrel",
  tags: ["creature","squirrel","low-poly","age-of-mcp","classic"],
  summary: "Low-poly squirrel.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: () => partsFor(),
  animations: [],
});
